import { useEffect, useRef } from 'react';

function publisCustomCss(parent: Element | null, styles: string) {
  if (!parent) {
    return;
  }

  const style = document.createElement('style');
  style.setAttribute('id', 'justifi-custom-css');

  style.textContent = styles;

  const origStyle = (Array.from(parent.childNodes) as HTMLElement[]).find(
    (node) => node.tagName === 'STYLE' && !node.id
  ) as HTMLStyleElement;

  try {
    const existing = parent.querySelector('#justifi-custom-css');
    // remove existing

    if (existing) {
      existing.remove();
    }

    if (origStyle?.nextSibling) {
      parent.insertBefore(style, origStyle?.nextSibling);
    } else if (parent.childNodes?.[1]) {
      parent.insertBefore(style, parent.childNodes[1]);
    } else {
      // we didn't find anything loaded yet.
      parent.appendChild(style);
    }
  } catch (err) {
    console.warn('Error appending custom css to shadow root', err);
  }
}

export const useJustifiOverrideStyles = ({
  selector,
  overrideStyles,
  dependencies,
}: {
  selector: () => HTMLElement | null | undefined;
  overrideStyles: string;
  dependencies: any[];
}) => {
  const attemptsRef = useRef(0);
  /**
   * Publish CSS on mount or re-render (when main mounting props change).
   */
  useEffect(() => {
    let id: NodeJS.Timeout | null = null;

    const attemptToPublishCustomCss = () => {
      const rootElement = selector();

      if (rootElement) {
        publisCustomCss(rootElement, overrideStyles);
      } else if (attemptsRef.current < 10) {
        id = setTimeout(() => {
          attemptsRef.current++;
          attemptToPublishCustomCss();
        }, 250);
      }
    };

    attemptToPublishCustomCss();

    // Cleanup
    return () => {
      id && clearTimeout(id);
    };
  }, dependencies);
};
